<template>
  <div>
    <!-- Title Input -->
    <b-row>
      <b-col sm="3">
        <b-input-group prepend="Titulo" size="sm" class="mt-4">
          <b-form-input
            v-model="translations[language].title"
            v-validate.initial="'required|max:30'"
            type="text"
            name="title"
            size="sm"
            :disabled="disabledInputs"
          />
        </b-input-group>
        <b-form-invalid-feedback
          :state="errors.collect('title').length === 0"
        >{{errors.first('title')}}</b-form-invalid-feedback>
      </b-col>
      <b-col sm="9">
        <!-- Short Descripion Input -->
        <b-input-group prepend="Desc. curta" size="sm" class="mt-4">
          <b-form-input
            v-model="translations[language].strong_desc"
            v-validate.initial="'required'"
            type="text"
            name="short desc"
            size="sm"
            placeholder="Descrição curta"
            :disabled="disabledInputs"
          />
        </b-input-group>
        <b-form-invalid-feedback
          :state="errors.collect('short desc').length === 0"
        >{{errors.first('short desc')}}</b-form-invalid-feedback>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="9">
        <!-- Descrição -->
        <b-input-group prepend="Descriçao" size="sm" class="mt-4">
          <b-form-textarea
            v-model="translations[language].description"
            v-validate.initial="'required'"
            placeholder="Descrição"
            name="descrição"
            rows="5"
            :disabled="disabledInputs"
          ></b-form-textarea>
        </b-input-group>
        <b-form-invalid-feedback
          :state="errors.collect('descrição').length === 0"
        >{{errors.first('descrição')}}</b-form-invalid-feedback>
      </b-col>
      <!-- Includes input -->
      <b-col>
        <b-input-group prepend="Inclui:" size="sm" class="mt-4">
          <b-form-textarea
            :value="inclui"
            v-on:input="(event) => this.$emit('update:inclui', event)"
            v-validate.initial="'required'"
            :placeholder="'inclui 1\ninclui 2'"
            name="inclui"
            rows="5"
            :disabled="disabledInputs"
          ></b-form-textarea>
        </b-input-group>
        <b-form-invalid-feedback
          :state="errors.collect('inclui').length === 0"
        >{{errors.first('inclui')}}</b-form-invalid-feedback>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "translationsTour",
  props: {
    title: { type: String, required: true },
    strongDesc: { tyoe: String, required: true },
    description: { tyoe: String, required: true },
    inclui: { type: String, required: true },
    disabledInputs: { type: Boolean, required: true },
    language: {
      type: String,
      required: true
    },
    translations: { required: true }
  }
};
</script>
